import React from "react";

const Security = () => {
  return (
    <div className="flex flex-col items-start  sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide ">
        D.
        <span className="text-[#01A7D1] "> Security</span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        We employ procedural and technological security measures, which are
        reasonably designed to help protect your personal information from
        unauthorized access or disclosure. Yostel may use encryption, passwords,
        and physical security measures to help protect your personal information
        against unauthorized access and disclosure. No security measures,
        however, are 100% complete. Therefore, we do not promise and cannot
        guarantee, and thus you should not expect, that your personal
        information or private communications will not be collected and used by
        others. You should take steps to protect against unauthorized access to
        your password,
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        phone, and computer by, among other things, signing off after using a
        shared computer, choosing a robust password that nobody else knows or
        can easily guess, and keeping your log-in and password private.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        Yostel is not responsible for the unauthorized use of your information
        or for any lost, stolen, compromised passwords, or for any activity on
        your Account via unauthorized password activity.
      </p>
    </div>
  );
};

export default Security;
